import type { FC } from 'react';
import type { BlockComponentProps } from '../BlockRenderer/types';
import useGetFallbackNode from '../DataSourceController/hooks/useGetFallbackComponent';
import { useIsEntitySuspended } from '../DataSourceController/hooks/useIsEntitySuspended';
import { ComputeContextHelper } from '../../hooks/computeContext/ComputeContextHelper';

function withSuspense<T, P, R>(Component: FC<BlockComponentProps<T, P, R>>) {
  return function SuspenseWrapper(props: BlockComponentProps<T, P, R>) {
    const { fallback, dataSourceIds, getGlobalStoreContext } = props;
    const context = getGlobalStoreContext();

    const { isSuspended } = useIsEntitySuspended({
      dataSourceIds,
      context,
    });

    const sessionStorage = ComputeContextHelper.getSessionStorage(context);

    const isLoadingSessionStorage = Boolean(sessionStorage?.isLoading);

    const { fallbackNode } = useGetFallbackNode({
      fallback,
      isSuspended,
    });

    if (isSuspended || isLoadingSessionStorage) return fallbackNode;

    return <Component {...props} />;
  };
}

export default withSuspense;
